import React, { useEffect, useState } from "react";

interface NoSsrProps {
  children: React.ReactNode;
}

const NoSsr: React.FC<NoSsrProps> = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? <>{children}</> : null;
};

export default NoSsr;
